import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { HowToPlayDialogComponent } from '@app/components/dialogs/how-to-play-dialog/how-to-play-dialog.component';
import { howToPlayActions } from '@app/store/tutorial/howToPlay.actions';

const openHowToPlayDialog = createEffect(
  () => {
    const actions$ = inject(Actions);
    const dialog = inject(MatDialog);

    return actions$.pipe(
      ofType(howToPlayActions.openHowToPlayDialog),
      tap(() => {
        dialog.open(HowToPlayDialogComponent, {
          maxWidth: '900px',
        });
      }),
    );
  },
  {
    functional: true,
    dispatch: false,
  },
);

export const howToPlayEffects = {
  openHowToPlayDialog,
};
